var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAi = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_ai",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ai-class-a {\n        fill: none !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(7.613 6.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M34.647,151.225H21.407a2.561,2.561,0,1,0,0,1.518h13.24a.759.759,0,0,0,0-1.518Zm-15.715,1.8a1.043,1.043,0,1,1,1.087-1.042A1.067,1.067,0,0,1,18.932,153.026Z",
    transform: "translate(-7.182 -137.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M34.845,160.382a16.874,16.874,0,0,0,1.285-2.732,1.092,1.092,0,0,0-1.022-1.48v0l-7.476-.069h-.006a.732.732,0,0,0-.666.429l-.674,1.487a2.507,2.507,0,1,0,1.508.213l.3-.664,5.686.053a11.373,11.373,0,0,1-1,1.928l-.307.417,2,7.854a1.1,1.1,0,0,0,1.061.825,1.061,1.061,0,0,0,.273-.034,1.1,1.1,0,0,0,.791-1.333Zm-8.14,1.057a1,1,0,1,1,1.046-1A1.027,1.027,0,0,1,26.705,161.44Z",
    transform: "translate(-8.558 -139.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M31.7,138.433a13.265,13.265,0,0,0-9.1-4.476,15.141,15.141,0,0,0-10.325,3.181,9.705,9.705,0,0,0-3.592,8.616l-3.042,6.32a2.093,2.093,0,0,0,.078,1.99A2.336,2.336,0,0,0,7.446,155.2l1.442.21v3.526a2.737,2.737,0,0,0,2.813,2.647h3.927l1.238,3.559a1.166,1.166,0,0,0,1.111.757,1.26,1.26,0,0,0,.364-.054,1.088,1.088,0,0,0,.747-1.388l-1.765-5.074H11.7a.463.463,0,0,1-.477-.448v-5.411l-3.454-.537,3.336-6.928-.069-.342a7.573,7.573,0,0,1,2.782-6.921,12.605,12.605,0,0,1,8.61-2.642,10.925,10.925,0,0,1,7.484,3.7,6.868,6.868,0,0,1,1.928,4.369H24.2l-.414-.858a2.476,2.476,0,0,0,1.6-2.263,2.682,2.682,0,0,0-5.347,0,2.528,2.528,0,0,0,2.106,2.414l.84,1.743a.783.783,0,0,0,.71.43h9.361a1.132,1.132,0,0,0,1.14-1.126A9,9,0,0,0,31.7,138.433Zm-10.1,2.667a1.122,1.122,0,1,1,1.116,1.007A1.067,1.067,0,0,1,21.605,141.1Z",
    transform: "translate(-5.43 -133.924)",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    className: "ai-class-a",
    "data-name": "Rectangle 550",
    width: 44,
    height: 44
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_ai.b13e86edf6c9a37b9f261262dc124b47.svg";